module.exports = __webpack_public_path__ + "assets/clubhouse-c9ad6fbcb75d630d8c144c7427b93dc3.png";